import React, { useState, useRef } from 'react';
import { Row, Col, Form, Button, Spinner, Container } from 'react-bootstrap';
// apis
import { handleCallExportFromDelvi } from 'api/exports';
//components
import FeedbackStatus from 'components/userzone/FeedbackStatus';
// images
import ExcelEansImg from '../../assets/img/excel_eans.png';

const ExportFromDilve = (props) => {
  const [file, setFile] = useState(null);
  const [disabledButton, setDisabledButton] = useState(false);
  const [errors, setErrors] = useState(null);

  const fileInputRef = useRef(null);

  const uploadDownload = async () => {
    setDisabledButton(true);
    setErrors(null);
    const formData = new FormData();
    formData.append('file', file);
    const response = await handleCallExportFromDelvi(formData);
    const { data, status } = response;
    if (status === 200) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = 'products_export_from_dilve.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      setErrors(
        'Algo salió mal, por favor intenta de nuevo. Asegurate de seguir las instrucciones que se muestran a la derecha.',
      );
    }
    fileInputRef.current.value = null;
    setDisabledButton(false);
  };

  return (
    <Container>
      <h3>Exportar desde Dilve</h3>
      <Row>
        <Col md={6} className="pt-2 mt-1">
          <div className="card text-white bg-dark mb-3 mt-4">
            <div className="card-body bg-dark">
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>Subir excel</Form.Label>
                <Form.Control
                  accept=".xlsx"
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  ref={fileInputRef}
                />
              </Form.Group>
              <FeedbackStatus feedbackType="error" isVisible={errors !== null} msgObject={errors} />
              <Button className="float-end" variant="success" onClick={uploadDownload} disabled={disabledButton}>
                Subir excel {disabledButton && <Spinner animation="border" size="sm" variant="light" />}
              </Button>
            </div>
          </div>
        </Col>
        <Col md={6}>
          <h4>Instrucciones</h4>
          <div className="d-flex">
            <div>
              <img width={320} src={ExcelEansImg} className="shadow rounded-3" />
            </div>
            <div>
              <ul>
                <li>
                  De preferencia usar un excel con la extensión <b>.xlsx</b>
                </li>
                <li>
                  La información debe estar solo en la primera columna, en la primera fila de poner "ISBN" a partir de
                  la segunda incluir los ISBN que se desen
                </li>
                <li>Las celdas del ISBN debe tener formato de texto</li>
                <li>
                  Puede tardar unos segundos en descargarse el archivo dependiendo del número de ISBN que se incluyan en
                  el excel
                </li>
                <li>
                  Para evitar que que la plataforma de error de timeout, no se permitirá que el excel tenga mas de 1000
                  registros, por cada excel que se cargue.
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ExportFromDilve;
